<template>
  <v-container fluid fill-height>
    <v-flex xs12>
      <v-layout row justify-center align-center>
        <v-img
          src="../../assets/Group 5@2x.png"
          max-height="360"
          max-width="360"
          aspect-ratio="1">
        </v-img>
      </v-layout>
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-card-text class="text-center subtitle-1 text--darken-4 mt-2">
            <span v-if="user.site">
              {{ user.site.toUpperCase() }} geçici olarak yanıt veremiyor.
            </span>
            <span v-else>
              Sunucumuz geçici olarak yanıt veremiyor.
            </span>
          </v-card-text>
        </v-flex>
        <v-flex d-flex xs12 justify-center>
          <v-btn text @click.stop="connect">Bağlanmayı Dene</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';

export default {
  name: 'NoConnection',
  data: () => ({ latestRoute: {} }),
  created() {
    this.status = '';
    this.latestRoute = this.$route.params.latest;
  },
  computed: {
    ...mapFields(['status', 'user']),
  },
  methods: {
    ...mapActions({ send: 'asyncSender' }),
    connect() {
      if (!this.$route.params.latest) {
        this.latestRoute = { name: 'dashboard' };
      }
      this.axios.get('alive')
        .then(() => this.$router.push({ name: this.latestRoute.name }));
    },
  },
};
</script>
